import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { borderRadius } from '@infl-ts/ui-advocate-theme';
import { ClearedLens, SuccessStateLens } from '@infl-ts/util-lens';
import { Box, css, Skeleton, styled, useMediaQuery } from '@mui/material';
import ProfileAutocomplete from '../../../profile-autocomplete';
import { Tooltip } from '../../../tooltip';
import ActionButton from './action-button';
import GroupAutocomplete from './group-autocomplete';
import LensLabel from './lens-label';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LoaderWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n"])), function (p) {
  return p.theme.palette.neutral.contrastText;
});
var AutocompleteWrapper = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    ", " {\n      flex-direction: column;\n    }\n  "])), theme.breakpoints.down('md'));
});
var ProfileAutocompleteWrapper = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    max-width: 350px;\n    min-width: 200px;\n    width: 100%;\n    ", " {\n      max-width: 100%;\n    }\n    ", " {\n      margin-left: 0;\n    }\n  "])), theme.spacing(1), theme.breakpoints.down('lg'), theme.breakpoints.down('md'));
});
var GroupAutocompleteWrapper = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-left: ", ";\n    max-width: 200px;\n    min-width: 150px;\n    width: 100%;\n    ", " {\n      margin-left: 0;\n    }\n    ", " {\n      margin-bottom: ", ";\n      max-width: 100%;\n    }\n  "])), theme.spacing(2), theme.breakpoints.down('lg'), theme.breakpoints.down('md'), theme.spacing(2));
});
var AutocompletePlaceholder = styled(Skeleton)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 40px;\n  border-radius: ", ";\n  background-color: rgba(255, 255, 255, 0.4);\n"])), function (props) {
  return borderRadius(props.theme);
});

var disabledTooltipText = function disabledTooltipText(lens) {
  return !lens || ClearedLens.is(lens) ? '' : 'Only 1 lens may be activated at a time. Clear your existing Lens in order to search for a new Lens.';
};

var LensLoader = function LensLoader(_ref4) {
  var lens = _ref4.lens,
      lensActionPending = _ref4.lensActionPending,
      actions = _ref4.actions,
      group = _ref4.group,
      setGroup = _ref4.setGroup,
      individual = _ref4.individual,
      setIndividual = _ref4.setIndividual,
      hasCorporateAccess = _ref4.hasCorporateAccess;
  var isTablet = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });
  return /*#__PURE__*/_jsxs(LoaderWrapper, {
    "data-element": "LoaderWrapper",
    "data-component": "LensLoader",
    "data-source-file": "index.tsx",
    children: [!isTablet && /*#__PURE__*/_jsx(LensLabel, {
      lens: lens
    }), /*#__PURE__*/_jsxs(AutocompleteWrapper, {
      "data-element": "AutocompleteWrapper",
      "data-component": "LensLoader",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: disabledTooltipText(lens),
        "data-element": "Tooltip",
        "data-component": "LensLoader",
        "data-source-file": "index.tsx",
        children: /*#__PURE__*/_jsx(GroupAutocompleteWrapper, {
          "data-element": "GroupAutocompleteWrapper",
          "data-component": "LensLoader",
          "data-source-file": "index.tsx",
          children: lens ? /*#__PURE__*/_jsx(GroupAutocomplete, {
            setGroup: setGroup,
            disabled: !ClearedLens.is(lens)
          }) : /*#__PURE__*/_jsx(AutocompletePlaceholder, {
            variant: "rectangular"
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          width: '100%'
        },
        "data-element": "Box",
        "data-source-file": "index.tsx",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: disabledTooltipText(lens),
          "data-element": "Tooltip",
          "data-source-file": "index.tsx",
          children: /*#__PURE__*/_jsx(ProfileAutocompleteWrapper, {
            "data-element": "ProfileAutocompleteWrapper",
            "data-source-file": "index.tsx",
            children: lens ? /*#__PURE__*/_jsx(ProfileAutocomplete, {
              value: individual,
              setValue: setIndividual,
              disabled: !ClearedLens.is(lens),
              groupId: group === null || group === void 0 ? void 0 : group.uuid,
              hasCorporateAccess: hasCorporateAccess,
              placeholder: "Search name, email, title, company"
            }) : /*#__PURE__*/_jsx(AutocompletePlaceholder, {
              variant: "rectangular"
            })
          })
        }), SuccessStateLens.is(lens) && individual && /*#__PURE__*/_jsx(ActionButton, {
          lens: lens,
          lensActionPending: lensActionPending,
          actions: actions
        })]
      })]
    })]
  });
};

export default LensLoader;